export const manageSearchAccessAreas = [
	"managedEvent",
	"archiveEvent",
	"archiveExam",
	"archiveVendor",
	"school",
	"archiveArtist",
	"album",
] as const;

export type ManageSearchAccessArea = (typeof manageSearchAccessAreas)[number];
